export const getUrlParameter = (name: string) => {
    // Firstly, get params from location search
    const searchParams = new URLSearchParams(window.location.search);
    let param = searchParams.get(name);
    if (param !== null) return param;

    // If no params, try to get params after hash
    const hashIndex = window.location.hash.indexOf('?');
    if (hashIndex > -1) {
        const hashSearch = window.location.hash.slice(hashIndex);
        const hashParams = new URLSearchParams(hashSearch);
        param = hashParams.get(name);
    }

    return param === null ? null : param;
};
